angular.module('tct.uploadService', ['tct.configService'])
  .factory('uploadService', uploadService);

uploadService.$inject = ['configService', '$http'];

function uploadService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/media/upload`;
  const factory = {
    uploadFile,
  };

  return factory;

  function uploadFile(file) {
    const url = basePath;
    const payload = new FormData();
    payload.append('file', file);

    const httpconfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };

    return $http.post(url, payload, httpconfig);
  }
}
